
export const BANK_CARDS_STATES = {
    bankCardsPage: 'bankCards',
    bankCardsOverviewTab: 'bankCardsOverview',
    bankCardsTransactionsTab: 'bankCardsTransactions'
}

/** Transaction tab route names (release/6.5.0 uses flat STATE_NAMES; alias for Health guidance). */
export const TRANSACTIONS_STATES = {
    transactionsPage: 'app.transactions',
    transactionsNewTab: 'transactionsNew',
    transactionsMappedTab: 'transactionsMapped',
    transactionsCategoriesTab: 'transactionsCategories',
    transactionsRulesTab: 'rules',
}

export const STATE_NAMES = {
    login: 'login',
    accountReceivables: 'app.accountReceivables',
    contractsPage: 'app.contractsPage',
    accountReceivablesOverview: 'app.accountReceivablesOverview',
    AROverview: 'accountReceivablesOverview',
    ARInvoices: 'accountReceivablesInvoices',
    ARMatching: 'accountReceivablesMatching',
    ARRules: 'invoices-rules',
    ARContracts: 'accountReceivablesContracts',
    companyARInvoices: 'companyAccountReceivablesInvoices',
    Contracts: 'contracts',
    budgetRules: 'budgetRules',
    financing: 'financing',
    loans: 'loans',
    otherContracts: 'other-contracts',
    matching: 'app.expected-matching-tab',
    authorizeSlack: 'authorizeSlack',
    signIn: 'sign-in',
    signUp: 'sign-up',
    restoreEmail: 'restore-email',
    restorePassword: 'restore-password',
    userActivate: 'user-activate',
    newPassword: 'new-password',
    activate: 'activate',
    app: 'app',
    matchedInvoices: 'app-expected-matched',
    dashboard: 'app.dashboard',
    dashboardsHome: 'dashboardsHome',
    dashboardsFunds: 'dashboardsFunds',
    dashboardsAccountbalance: 'dashboardsAccountbalance',
    dashboardsBankAccounts: 'dashboardsBankAccounts',
    transactions: 'app.transactions',
    transactionsNew: 'transactionsNew',
    transactionsMapped: 'transactionsMapped',
    transactionsCategories: 'transactionsCategories',
    rules: 'rules',
    expectedTransactions: 'expectedTransactions',
    planning: 'app.planning',
    /** Child of {@link STATE_NAMES.planning}; company-level planning shell (`/planning`). */
    planningCompany: 'planningCompany',
    /** Child of {@link STATE_NAMES.planning}; group-level planning (`/planning/group`). */
    planningGroup: 'planningGroup',
    /** Smart Planning shell under planning (`/planning/smart-planning`). */
    planningSmartPlanning: 'planningSmartPlanning',
    sidepanel: 'sidepanel',
    budget: 'budgets',
    planningOld: 'app.planningOld',
    reporting: 'app.reporting',
    reportTab: 'reportTab',
    savedReport: 'savedReport',
    dataRoom: 'app.dataRoom',
    setup: 'app.setup',
    setupCompanyInfo: 'setupCompanyInfo',
    setupBankAccounts: 'setupBankAccounts',
    setupConnectedAccounts: 'setupConnectedAccounts',
    setupTeam: 'setupTeam',
    setupIntegration: 'setupIntegration',
    home: 'app.home',
    userProfile: 'app.userProfile',
    userProfileInfo: 'userProfileInfo',
    twoFactorManage: 'app.twoFactorManage',
    //TODO: remove
    userProfileAccount: 'userProfileAccount',
    userProfileBankAccount: 'userProfileBankAccount',
    userProfileCompanies: 'userProfileCompanies',
    profileConnectedAccounts: 'profileConnectedAccounts',
    profileBankAccounts: 'profileBankAccounts',
    //
    integrationsGlobal: 'integrationsGlobal',
    integrationsAll: 'integrationsAll',
    integrationsAddOns: 'integrationsAddOns',
    integrationsApi: 'integrationsApi',
    integrationsPayments: 'integrationsPayments',
    integrationsAccounting: 'integrationsAccounting',
    integrationsUploaders: 'integrationsUploaders',
    integrationsArAp: 'integrationsArAp',
    integrationsRading: 'integrationsRading',
    progress: 'app.progress',
    //account settings
    settings: 'app.settings',
    settingsCompanies: 'app.settingsCompanies',
    settingsInvitations: 'app.settingsInvitations',
    settingsAccount: 'app.settingsAccount',
    settingsConnectedAccounts: 'settingsConnectedAccounts',
    settingsBankAccounts: 'settingsBankAccounts',
    settingsBanks: 'app.settingsBanks',
    insights: 'app.insights',
    insightsOutlookTab: 'insightsOutlookTab',
    insightsCashBurnTab: 'insightsCashBurnTab',
    insightsActualsTab: 'insightsActualsTab',
    insightsDeviationsTab: 'insightsDeviationsTab',
    insightsDetailsTab: 'insightsDetailsTab',
    insightsAIForecastTab: 'insightsAIForecastTab',
    //payables
    payables: 'app.payables',
    payablesList: 'payables-list',
    payablesVerify: 'payables-verify',
    payablesInApproval: 'payables-in-approval',
    payablesToBePaid: 'payables-to-be-paid',
    payablesInPayment: 'payables-in-payment',
    payablesOpen: 'payables-open',
    payablesPaid: 'payables-paid',
    payablesCancelled: 'payables-cancelled',
    payablesExported: 'payables-exported',
    payablesApprovals: 'payables-approval',
    payablesAll: 'payables-all',
    counterpartsList: 'counterparts-list',
    tagsList: 'tags-list',
    paymentRun: 'payment-run',
    approvalPoliciesList: 'approval-policies',
    moniteInvoices: 'monite-invoices',
    onboarding: 'onboarding',
    moniteCounterparts: 'monite-counterparts',
    moniteTags: 'monite-tags',
    moniteApprovalPolicies: 'monite-approval-policies',
    aiRules: 'ai-rules',
    ...BANK_CARDS_STATES
};

/**
 * UI-Router may expose either a short leaf name (`planningCompany`) or a dotted path
 * (`app.planning.planningCompany`). Match both so hooks and guards stay reliable.
 */
export function uiRouterStateMatches(stateName: string | undefined | null, registeredName: string): boolean {
    if (!stateName || !registeredName) {
        return false;
    }
    if (stateName === registeredName) {
        return true;
    }
    return stateName.endsWith('.' + registeredName);
}

/** True when `stateName` is the Smart Planning shell route. */
export function isPlanningSmartPlanningBranch(stateName: string | undefined | null): boolean {
    return uiRouterStateMatches(stateName, STATE_NAMES.planningSmartPlanning);
}

/**
 * True when `stateName` is within the Transactions/AI Rules branch (incl. tab child states).
 * Derived from {@link TRANSACTIONS_STATES} so newly added tabs are covered automatically.
 */
export function isTransactionsPageBranch(stateName: string | undefined | null): boolean {
    return [...Object.values(TRANSACTIONS_STATES), STATE_NAMES.aiRules].some((name) =>
        uiRouterStateMatches(stateName, name)
    );
}

/** True when the active UI-Router state is Planning or a nested planning route (incl. sidepanel/budget chain). */
export function isPlanningShellActiveRoute(stateName: string): boolean {
    return (
        uiRouterStateMatches(stateName, STATE_NAMES.planning) ||
        uiRouterStateMatches(stateName, STATE_NAMES.planningCompany) ||
        uiRouterStateMatches(stateName, STATE_NAMES.planningGroup) ||
        isPlanningSmartPlanningBranch(stateName) ||
        uiRouterStateMatches(stateName, STATE_NAMES.sidepanel) ||
        uiRouterStateMatches(stateName, STATE_NAMES.budget)
    );
}
